import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

const Home       = lazy(() => import('./pages/Home'));
const Hotel      = lazy(() => import('./pages/Hotel'));
const HotelArea  = lazy(() => import('./pages/HotelArea'));
const Dining     = lazy(() => import('./pages/Dining'));
const DiningArea = lazy(() => import('./pages/DiningArea'));
const Spa        = lazy(() => import('./pages/Spa'));
const Golf       = lazy(() => import('./pages/Golf'));
const GolfArea   = lazy(() => import('./pages/GolfArea'));
const Beach      = lazy(() => import('./pages/Beach'));
const Tennis     = lazy(() => import('./pages/Tennis'));
const Conference = lazy(() => import('./pages/Conference'));
const Engagement = lazy(() => import('./pages/Engagement'));
const Connection = lazy(() => import('./pages/Connection'));
const Solution   = lazy(() => import('./pages/Solution'));
const AboutUs    = lazy(() => import('./pages/AboutUs'));

function App() {
  return (
    <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        {/* Hotel main map + sub-areas */}
        <Route path="hotel" element={<Hotel />} />
        <Route path="hotel/lobby" element={<HotelArea area="lobby" />} />
        <Route path="hotel/pool" element={<HotelArea area="pool" />} />
        <Route path="hotel/gran-n-go" element={<HotelArea area="market" />} />
        <Route path="hotel/gifts" element={<HotelArea area="gifts" />} />
        <Route path="hotel/office" element={<HotelArea area="office" />} />
        <Route path="hotel/valet" element={<HotelArea area="valet" />} />
        <Route path="hotel/shipping" element={<HotelArea area="shipping" />} />
        <Route path="hotel/guest" element={<HotelArea area="guest" />} />

        {/* Dining and sub-areas */}
        <Route path="dining" element={<Dining />} />
        <Route path="dining/restaurant" element={<DiningArea area="restaurant" />} />
        <Route path="dining/casual" element={<DiningArea area="casual" />} />
        <Route path="dining/kitchen" element={<DiningArea area="kitchen" />} />

        {/* Top-level venue pages */}
        <Route path="spa" element={<Spa />} />
        <Route path="golf" element={<Golf />} />
        <Route path="golf/cart" element={<GolfArea area="cart" />} />
        <Route path="golf/hall" element={<GolfArea area="hall" />} />
        <Route path="golf/club" element={<GolfArea area="club" />} />
        <Route path="golf/shop" element={<GolfArea area="shop" />} />
        <Route path="beach" element={<Beach />} />
        <Route path="tennis" element={<Tennis />} />
        <Route path="conference" element={<Conference />} />
        <Route path="engagement" element={<Engagement />} />
        <Route path="connection" element={<Connection />} />

        {/* Solution detail pages */}
        <Route path="solutions/:id" element={<Solution />} />
        <Route path="aboutus" element={<AboutUs />} />
        <Route path="aboutus/agilysys" element={<AboutUs />} />
      </Route>
    </Routes>
    </Suspense>
  );
}

export default App;
